import { useJamChallenge } from '@/src/store/jam-challenge.context';
import { useJamEventDetails } from '@/src/store/jam-event-details.context';
import { IJamChallenge } from '@/src/types/JamChallenges';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { Box, ContentLayout, Header, SpaceBetween } from '@amzn/awsui-components-react';
import { Location } from 'history';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import ExpandableFeedback from '../../ui/organisms/MyJams/JamFeedback/ExpandableFeedback/index';

const getChallengeIdFromLocation = (location: Location) => {
  const search = location.search;
  const searchParams = new URLSearchParams(search);
  return searchParams.get('challengeId');
};

const JamFeedback = () => {
  const { t } = useTranslation();
  const { event } = useJamEventDetails();
  const { jamChallengeData } = useJamChallenge();
  const location = useLocation();

  const challengeId = getChallengeIdFromLocation(location);

  return (
    <ContentLayout header={<Header variant="h1">{t(i18nKeys.myJams.feedback.title)}</Header>}>
      <Box margin={{ bottom: 'xxl' }}>
        <SpaceBetween direction="vertical" size="l">
          {!challengeId && (
            <ExpandableFeedback
              headerText={event?.title ?? 'Jam Event Feedback'}
              data-testid="event-feedback-expandable"
            />
          )}
          {jamChallengeData?.challenges &&
            jamChallengeData?.challenges
              ?.filter((challenge: IJamChallenge) => {
                if (challengeId) {
                  return challengeId === challenge.id && !challenge.locked;
                }
                return !challenge.locked;
              })
              .map((challenge: IJamChallenge) => (
                <ExpandableFeedback
                  key={challenge.id}
                  challengeId={challenge.id}
                  headerText={`${t(i18nKeys.myJams.challenges.challenge)}: ${challenge.title ?? '[Challenge Title]'}`}
                  isEvent={false}
                  data-testid={`${challenge.id}-feedback-expandable`}
                />
              ))}
        </SpaceBetween>
      </Box>
    </ContentLayout>
  );
};

export default JamFeedback;
